import { render, staticRenderFns } from "./TagsInput.vue?vue&type=template&id=695c4e2c&"
import script from "./TagsInput.vue?vue&type=script&lang=ts&"
export * from "./TagsInput.vue?vue&type=script&lang=ts&"
import style0 from "./TagsInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSelect from 'quasar/src/components/select/QSelect.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSelect,QField});
